<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-datasett
    v-model="selectedItemIds"
    data-url="admin/dataset/"
    data-key="datasets"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="dataset-list"
  >
    <template #item.types="{ item }">
      <div v-for="t in item.types" :key="t.id">
        {{ t.name }}
      </div>
    </template>
    <template #item.alias="{ value }">
      {{ value || "-" }}
    </template>
    <template #item.last_updated_at="{ value }">
      {{ value ? $parseDate(value) : "" }}
    </template>
    <template #item.latest_period="{ value }">
      {{ $parsePeriod(value) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItem(item)"> More </v-btn>
        <v-btn
          v-if="item.data_type === 'MANUAL'"
          text
          color="primary"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "DatasetList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("dataset.types"), value: "types", width: 100 },
      { text: root.$t("dataset.title"), value: "title", sortable: false },
      {
        text: root.$t("dataset.alias"),
        value: "alias",
        width: 200,
      },
      {
        text: root.$t("dataset.last_updated_at"),
        value: "last_updated_at",
        width: 200,
      },
      {
        text: root.$t("dataset.latest_data"),
        value: "latest_period",
        width: 200,
      },
      { text: "", value: "actions", sortable: false },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-dataset",
        params: { datasetId: item.id },
      });
    };

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete Dataset?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/delete/",
          params: { dataset_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    };
  },
};
</script>

<style lang="less">
.dataset-list {
}
</style>
